<template>
	<div class="double-input-wrapper">
		<!-- Min Value Input -->
		<input-amount
		:inputValue="minValueParams.inputValue"
		:params="minValueParams"
		@input="[emit('inputMinValue', $event), removeErrors(), validateAmountPair('onlyValidateIfValid')]"
		@onBlur="validateAmountPair()"/>
		<!-- Max Value Input -->
		<input-amount
		class="max-input"
		:inputValue="maxValueParams.inputValue"
		:params="{...maxValueParams, errorMessage: maxValueErrorMessage}"
		@input="[emit('inputMaxValue', $event), removeErrors()], validateAmountPair('onlyValidateIfValid')"
		@onBlur="validateAmountPair()"/>
	</div>
</template>

<script setup>
/* Components */
import InputAmount from '@/components/generic/inputs/Amount'

/* Assets */
import { validateMaxAboveMinAmount } from '@/assets/scripts/amounts'

/* Vue */
import { ref, computed } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['inputMinValue', 'inputMaxValue', 'maxValueError', 'pairIsInvalid'])

/** props received
*@minValueParams {
    - labelText {String}: label for textField
    - placeholder {String}: text for placholder
    - currency {String}: Input Currency
    - mandatory { Boolean }
    - bottomMessage {String}: text to display in bottom elements
    - bottomElementsInLine { Boolean }
    - minValue {String, Number}
    - maxValue {String, Number}
	- inputValue {String, Number}: value to be displayed in input
	- allowNegativeValues {Boolean}: prop to allow negative amounts
	- errorState {Boolean}: property to show if input has error or not
}
*@maxValueParams {
    - labelText {String}: label for textField
    - placeholder {String}: text for placholder
    - currency {String}: Input Currency
    - mandatory { Boolean }
    - bottomMessage {String}: text to display in bottom elements
    - bottomElementsInLine { Boolean }
    - minValue {String, Number}
    - maxValue {String, Number}
	- inputValue {String, Number}: value to be displayed in input
	- allowNegativeValues {Boolean}: prop to tell input if it can have negative amounts
	- errorState {Boolean}: property to show if input has error or not
}
*/
const props = defineProps({
	minValueParams: Object,
	maxValueParams: Object
})

const maxValueError = ref(false)

const maxValueErrorMessage = computed(() => {
	if (!props.maxValueParams.inputValue) return

	return !props.maxValueParams.allowNegativeValues && Number(props.maxValueParams.inputValue) === 0 ? t('invalidAmount') : t('maxValueLessThanMinValError')
})

const validateAmountPair = (onlyValidateIfValid) => {
	/* If we dont allow negative values */
	if (!props.maxValueParams.allowNegativeValues && props.maxValueParams.inputValue && Number(props.maxValueParams.inputValue) === 0) {
		maxValueError.value = true

		if (!onlyValidateIfValid) emit('maxValueError', maxValueError.value)
		emit('pairIsInvalid', maxValueError.value)
		return
	}

	if (props.maxValueParams.inputValue && props.minValueParams.inputValue) {
		maxValueError.value = !validateMaxAboveMinAmount(props.maxValueParams.inputValue, props.minValueParams.inputValue)

		if (!onlyValidateIfValid) emit('maxValueError', maxValueError.value)
		emit('pairIsInvalid', maxValueError.value)
	}
}

const removeErrors = () => {
	emit('maxValueError', false)
	emit('pairIsInvalid', false)
	maxValueError.value = false
}
</script>

<style lang="scss" scoped>
.double-input-wrapper {
    width: 100%;
	position: relative;

    display: flex;
    flex-direction: column;

	.max-input {
		margin-top: 24px;
	}
}
</style>
